import { Outlet } from "react-router-dom";
import { useSetAtom } from 'jotai';
import { useSnackbar } from "notistack";

// local
import { defs } from "@common/const_defs";
import TopBar from "./TopBar";
import Footer from "./Footer";
import { handleOpenDlgContactUs, handleCloseDlgContactUs, ContactUsDialog } from "../pages/contact/ContactUsDialog";
import { ContactUsData } from "@data/contact-us";
import { post_contact_us_mail } from '@api/misc';

const MainLayout = () => {
    const { enqueueSnackbar } = useSnackbar();
    const openContactUsDlg = useSetAtom(handleOpenDlgContactUs);
    const closeContactUsDlg = useSetAtom(handleCloseDlgContactUs);

    const handleAction = async (act: string, vd: unknown) => {
        if (act === defs.kAct_ViewContactUsOpen) {
            openContactUsDlg(handleAction)
        } else if (act === defs.kAct_ViewContactUsCancel) {
            closeContactUsDlg()
        } else if (act === defs.kAct_ExecContactUsSend) {
            await post_contact_us_mail(vd as ContactUsData);
            enqueueSnackbar(`ご問い合わせ、ありがとうございます。`, { variant: "success" });
            closeContactUsDlg()
        }
    }
    return (
        <div className="landing">
            <TopBar onAction={handleAction} />
            <Outlet />
            <Footer onAction={handleAction} />
            <ContactUsDialog onAction={handleAction} />
        </div>
    );
};

export default MainLayout;
export { MainLayout };